
    // IMPORTS
    import { computed, defineComponent, PropType, ref } from 'vue'
    import { buildLocalization } from '@/util'

    import { Button } from '@progress/kendo-vue-buttons'
    import { DialogActionsBar } from '@progress/kendo-vue-dialogs'
    import AppDialog from '@/components/common/app-dialog.vue'
    import { NotificationDTO, useNotificationStore } from '@/store/notification'

    export default defineComponent({
        name: 'orderProposalUrlDialog',

        components: {
            'k-button': Button,
            AppDialog,
            DialogActionsBar
        },

        props: {
            orderProposalNo: { type: Number as PropType<number>, required: true },
            cartId: { type: String as PropType<string>, required: true },
            name: { type: String as PropType<string>, default: '' }
        },

        emits: ['close'],

        setup(props) {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/
            const { localize } = buildLocalization()
            const notificationStore = useNotificationStore()
            const urlInput = ref<HTMLInputElement | null>(null)

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const orderProposalNoFormatted = computed(() => `JSP-${String(props.orderProposalNo).padStart(7, '0')}`)
            const cartUrl = computed(() => `${window.location.origin}/cart/content?id=${props.cartId}`)

            const computedData = { orderProposalNoFormatted, cartUrl }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            function copyToClipboard() {
                navigator.clipboard.writeText(cartUrl.value)
                    .then(() => {
                        notificationStore.addNotification(
                            new NotificationDTO(localize('CopiedToClipboard'), 'success')
                        )
                    })
            }

            function openInNewTab() {
                window.open(cartUrl.value, '_blank')
            }

            const publicMethods = { localize, copyToClipboard, openInNewTab }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { urlInput, ...computedData, ...publicMethods }
        }
    });
